/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_NeedsInputs */

const en_mk_desktop_needs = /** @type {(inputs: Mk_Desktop_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires Node.js 22+ and separately installed Claude Code or Codex.`)
};

const id_mk_desktop_needs = /** @type {(inputs: Mk_Desktop_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memerlukan Node.js 22+ dan Claude Code atau Codex yang dipasang terpisah.`)
};

/**
* | output |
* | --- |
* | "Requires Node.js 22+ and separately installed Claude Code or Codex." |
*
* @param {Mk_Desktop_NeedsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_needs = /** @type {((inputs?: Mk_Desktop_NeedsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_NeedsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_needs(inputs)
	return en_mk_desktop_needs(inputs)
});